<div class="header__topbar" #headerElement cy-header-menu [ngClass]="{header__topbar_sticky: isScrolled}">
  <div class="container-xxl container-fluid">
    <div class="row">
      <div class="col">
        <p-menubar [model]="items">
          <ng-template #start>
            @if (startHeaderTemplate) {
            <ng-template *ngTemplateOutlet="startHeaderTemplate"></ng-template>
            } @else {
            <a href="#">
              <img class="header__start__logo" [imageDirective]="{
                src : 'assets/img/logo.svg'
              }">
            </a>
            }
          </ng-template>

          <ng-template #item let-item let-root="root">
            <!-- <div #itemsLink></div> -->
            @if(itemHeaderTemplate) {
            <ng-template *ngTemplateOutlet="itemHeaderTemplate"></ng-template>
            } @else if (root) {
            <a [attr.href]="item.items ? null : item.url" [attr.target]="item.target || null"
              class="flex align-items-center gap-2 p-menuitem-link bg-white header__menu-item"
              [class.header__menu-item--has-children]="!!item.items" (click)="item.items && $event.preventDefault()">
              @if (item.icon) {
              <i class="header__menu-item__icon" [class]="item.icon" aria-hidden="true"></i>
              }
              <span class="font-M1 font-S-sm regular muted_9" [attr.cy-label]="item.label">
                {{ item.label }}
              </span>
              @if (item.items) {
              <i class="pi pi-angle-down header__menu-item__chevron" aria-hidden="true"></i>
              }
            </a>
            } @else {
            <a RouteNavigate [subRoute]="item.subRoute" [inNewTab]="item.target === '_blank'"
              class="header__submenu-item gap-2" [attr.cy-label]="item.label">
              @if (item.icon) {
              <i class="header__submenu-item__icon" [class]="item.icon" aria-hidden="true"></i>
              }
              <span class="header__submenu-item__label">{{ item.label }}</span>
            </a>
            }

          </ng-template>

          <ng-template #end>
            @if(endHeaderTemplate){
            <ng-template *ngTemplateOutlet="endHeaderTemplate"></ng-template>
            } @else {
            <div class="d-flex align-items-center">
              <!-- <div class="header__call" (click)="phoneCall()">
                <span class="font-M2-lg font-M2-md font-M2-sm bold">۰۳۵-۳۸۳۴۲۳۱۷</span>
                <i class="isax icon-call"></i>
              </div> -->
              <app-button-loader class="header__login_button" [button]="loginRegisterButton"></app-button-loader>
              <div class="d-flex align-items-center relative">
                @if(dashboardBtn?.label && isAuthenticated){
                <app-button-loader class="header__login_button" [button]="dashboardBtn"></app-button-loader>
                }

                @if(opened) {
                <div #panel class="tiered-menu-panel" [class.open]="opened" [ngClass]="class"
                  [attr.aria-hidden]="!opened" role="menu">
                  <ul class="tiered-menu-list">
                    @for(item of dropDownOptions; track $index){
                    <li [class.d-none]="item.isVisible === false">
                      @if(item.separator) {
                      <div class="tiered-separator"></div>
                      } @else {
                      <a RouteNavigate [subRoute]="item.routerLink" class="tiered-item" role="menuitem"
                        (changeVisiblity)="updateDropDownVisibility(item, $event)" (click)="hide(); item?.command?.()"
                        [ngClass]="item.styleClass ? item.styleClass : ''" [attr.cy-button]="item.label">
                        <div class="tiered-item-left d-flex align-items-center">
                          <span *ngIf="item.icon" class="tiered-item-icon" [class]="item.icon"></span>
                          <span class="tiered-item-label">{{ item.label }}</span>
                        </div>
                        <div class="tiered-item-right">
                          <ng-container *ngIf="item.templateRef">
                            <ng-container [ngTemplateOutlet]="item.templateRef"></ng-container>
                          </ng-container>
                        </div>
                      </a>
                      }
                    </li>
                    }
                  </ul>
                </div>
                }
              </div>
            </div>
            }
          </ng-template>
        </p-menubar>

      </div>
      <div class="header__navbar">
        @if(!buttonNavigateTemplate){
        <div class="d-flex justify-content-center text-center">
          <a RouteNavigate class="font-XS-md font-XS-sm bold" [subRoute]="home" [routerLinkActive]="'active'"
            [routerLinkActiveOptions]="{ exact: false }">
            <i class="isax icon-home-2 mt-3"></i>
            <span>خانه</span>
          </a>

          <a class="font-XS-md font-XS-sm bold" (click)="navigateToPanel()">
            <i class="isax icon-user mt-3"></i>
            <span>حساب کاربری</span>
          </a>
        </div>
        } @else {
        <ng-template *ngTemplateOutlet="buttonNavigateTemplate"></ng-template>
        }
      </div>
    </div>
  </div>
</div>

<ng-template #notificationPannelMenu>
  @if(notificationCount > 0){
  <p-badge [value]="notificationCount" [attr.cy-content]="notificationCount" severity="danger" />
  }
</ng-template>